import React, { FC } from 'react'
import { AddFeatureDialog } from './components/AddFeatureDialog'
import { Confirmation } from '../shared/Confirmation'
import { useMapEditorContext } from 'context/map-editor-context'

export const AddFeatureWizard: FC = () => {
  const [{ confirmed, editor, areaTool, editingLayer }, mapEditorDispatch] = useMapEditorContext()

  if (confirmed) {
    return <AddFeatureDialog feature={editor.feature!} areaTool={areaTool} layer={editingLayer!} />
  }

  return <Confirmation onConfirm={() => mapEditorDispatch.setConfirm(true)} />
}

AddFeatureWizard.displayName = 'AddFeatureWizard'
